import { createElement, memo, useState } from '@max/max';
import CrossEndVapView from './index.web';
import { getIsSupportVap } from './utils';
const isMRN = false;
import { TechStackUtil } from '@nibfe/mkt-common-utils';
const VapView = (props) => {
    var _a;
    const isHarmony = (_a = TechStackUtil.isInHarmony) === null || _a === void 0 ? void 0 : _a.call(TechStackUtil);
    const [isSupportVap] = useState(getIsSupportVap());
    if (!isSupportVap) {
        return null;
    }
    return <CrossEndVapView {...props}/>;
};
export default memo(VapView);
